import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDoctor } from "js/redux/actions/diagnoses";
import { animate, stagger } from "motion";

import video_logo from "assets/icons/video-icon.svg";
import video from "assets/icons/video.svg";
import camera from "assets/icons/camera.svg";
import { getDateFormat } from "js/HelperMethods";
import DoubleImageViewer from "./DoubleImageViewer";

function Consultation({
  uuid,
  diagnosed,
  charged,
  category,
  overviews,
  doctor,
  t,
  i18n,
  patient,
  appointment,
  rejected_by,
  closeupImages,
  pageNo,
}) {
  const navigate = useNavigate();
  const goToDetailView = () => {
    localStorage.setItem("pageNo", pageNo);
    const status =
      diagnosed === 1
        ? "Complete"
        : getStatus(appointment, category, rejected_by);
    navigate(`/dashboard/summary/${uuid}/${encodeURIComponent(status)}`);
  };

  useEffect(() => {
    animate(
      ".consultation",
      {
        transform: ["translateY(-40px)", "translateY(0px)", "none"],
        opacity: [0, 1],
      },
      { delay: stagger(0.05) }
    );
  }, []);

  const getDays = (appointment) => {
    if (appointment) {
      const targetDate = new Date(appointment.booked_to);

      // Current date
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      // Calculate the difference in milliseconds
      const timeDifference = targetDate - currentDate;

      // Convert milliseconds to days (rounded down)
      const daysLeft = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      console.log("days", daysLeft);
      return daysLeft;
    }
  };

  const getStatus = (appointment, category, rejected_by) => {
    if (diagnosed) {
      return "Complete";
    } else if (rejected_by != null) {
      return t("dashboard.state.action_required");
    }
    if (category === "video") {
      if (getDays(appointment) === 0) {
        return t("dashboard.state.appointment_today");
      } else if (getDays(appointment) > 0) {
        return `${t("dashboard.state.appointment_in")} ${getDays(
          appointment
        )} ${t("dashboard.state.days")}`;
      } else {
        return "Complete";
      }
    } else if (category === "picture") {
      return t("dashboard.state.under_assessment");
    }
  };

  return (
    <>
      <div className="consultation">
        {
          <div className="image-div">
            {category === "video" ? (
              <img src={video_logo} alt="" />
            ) : closeupImages[0].is_visible === 0 ? (
              <img src={video_logo} alt="" />
            ) : (
              overviews.length > 0 && (
                <DoubleImageViewer closeupImages={closeupImages} />
              )
            )}
          </div>
        }
        {diagnosed ? (
          <>
            <div data-title={`${t("case.assigned_to")}:`} className="dr-name">
              <span>
                {doctor && (
                  <>
                    <strong>Dr {doctor[doctor.length - 1].display_name}</strong>
                  </>
                )}
              </span>
            </div>
          </>
        ) : (
          <span data-title={`${t("case.assigned_to")}:`} className="dr-name">
            <span>
              {category === "video"
                ? t("dashboard.doctor_status.assigned")
                : t("dashboard.doctor_status.unassigned")}
            </span>
          </span>
        )}
        <span
          data-title={`${t("case.consultation_type")}:`}
          className="category"
        >
          {category === "video" ? (
            <img src={video} alt="" />
          ) : (
            <img src={camera} alt="" />
          )}
        </span>
        <span data-title={`${t("case.patient")}:`} className="pt-name">
          {patient.firstname} {patient.lastname}
        </span>
        {getStatus(appointment, category, rejected_by) === "Complete" ? (
          <span data-title={`${t("case.status")}:`} className="status success">
            {t("dashboard.state.complete")}
          </span>
        ) : (
          <span data-title={`${t("case.status")}:`} className="status">
            {getStatus(appointment, category, rejected_by)}
          </span>
        )}

        <span data-title={`${t("case.booked")}:`} className="date">
          {getDateFormat(charged, i18n.language)}
        </span>

        <button className="view-button" onClick={goToDetailView}>
          <strong>{t("dashboard.action.view")}</strong>
        </button>
      </div>

      <div className="consultation-mobile" onClick={goToDetailView}>
        <div className="doctor-status-wrapper">
          {category === "video" ? (
            <img src={video} alt="" />
          ) : (
            <img src={camera} alt="" />
          )}
          <span className="date">20.6.25</span>
          <span className="doctor-status">
            {t("dashboard.doctor_status.unassigned")}
          </span>
        </div>
        {category === "picture" && overviews.length > 0 && (
          <div className="image-div">
            <DoubleImageViewer closeupImages={closeupImages} />
          </div>
        )}
        <div className="status-wrapper">
          <span className="doctor-name-text">
            {patient.firstname} {patient.lastname}
          </span>
          {getStatus(appointment, category, rejected_by) === "Complete" ? (
            <span
              data-title={`${t("case.status")}:`}
              className="status success"
            >
              {t("dashboard.state.complete")}
            </span>
          ) : (
            <span data-title={`${t("case.status")}:`} className="status">
              {getStatus(appointment, category, rejected_by)}
            </span>
          )}
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    doctors: state.diagnoses.doctors,
  };
}

export default connect(mapStateToProps, {
  getDoctor,
})(withTranslation()(Consultation));
